import { getLabelStyle } from './SharedInputStyle';

const InputWrapper = {
  styles: (theme) => ({
    label: {
      ...getLabelStyle(theme),
    },
  }),
};

export default InputWrapper;
